<template>
    <PullContainer
        ref="pullContainerRef"
        :pullDownLoading="true"
        :pullDownLabel="true"
        @pullDownLoadingSuccess="pullDownLoadingSuccess"
    >
        <template #container>
            <div class="public_container customer_private_seas_wrap" v-loading="loading">
                <div class="returnNavBar">
                    <ReturnNavBar title="返回" :isTitleNormal="true" :isAllFunctions="true" :isCustomReturnEvent="true" @returnEvent="handleClickReturnRouter"> </ReturnNavBar>
                    <div class="returnNavBarRight">
                        <van-popover
                            ref="top_operator_popover"
                            v-model="showOperatorPopover"
                            class="top_operator_popover"
                            placement="bottom-end"
                            trigger="click"
                        >
                            <div class="top_operator_list">
                                <li v-for="item in operatorList" :key="item.type" @click="handleClickOperate(item)">
                                    <i :class="['iconfont', item.icon]"></i><span>{{ item.title }}</span>
                                </li>
                            </div>
                            <template #reference>
                                <i class="iconfont icon-a-tianjiamiaobian"></i>
                            </template>
                        </van-popover>
                    </div>
                </div>
                <div class="top_search">
                    <van-search
                        v-model="searchForm.keyword"
                        placeholder="请输入查询内容"
                        @clear="onSearch"
                        @search="onSearch"
                    >
                        <template #right-icon>
                            <i class="iconfont icon-shaixuan" @click="handleClickAdvancedFilter"></i>
                        </template>
                    </van-search>
                </div>
                <div class="mobile_container">
                    <div class="no-empty-list" v-if="!tableData.length">
                        <img
                            alt=""
                            src="https://download.hecoos.com/enlightv/2024-48/4e42cbd3ef1bb6ec5d6f0de2b536b48d.png"
                        />
                        <p>暂无客户</p>
                        <div class="btns">
                            <van-button type="default" class="default_btn"
                                ><i class="iconfont icon-renyuan"></i>前往申领
                            </van-button>
                            <van-button type="info" class="add_btn" @click="handleClickAdd"
                                ><van-icon name="plus"></van-icon>新建客户</van-button
                            >
                        </div>
                    </div>
                    <ul class="list_wrap" v-infinite-scroll="onLoadList">
                        <li v-for="item in tableData" :key="item.id" class="list_item">
                            <div class="list_item_info" @click="handleClickToDetail(item)">
                                <p>
                                    <span class="ellipsis">{{ item.name && item.name.value }}</span
                                    ><span v-if="item.status == '2'" class="item_status1">申领中</span>
                                </p>
                                <div
                                    class="img_info"
                                    v-if="item.salesperson && item.salesperson.text && item.salesperson.text.length"
                                >
                                    <div class="img_avatar_wrap">
                                        <img :src="item.salesperson.text[0].avatar || defaultImg" alt="" />
                                    </div>
                                    <span>{{ item.salesperson.text[0].name }}</span>
                                </div>
                            </div>
                            <div class="list_item_checkbox" v-if="isCheck">
                                <van-checkbox
                                    v-model="item.checked"
                                    shape="square"
                                    @change="handleClickChangeSelect(item)"
                                ></van-checkbox>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="batch_select_icon" v-if="isCheck" @click="handleClickShowCompany">
                    <i class="iconfont icon-renyuan"></i
                    ><span v-if="selectedList.length">{{ selectedList.length }}</span>
                </div>
                <SelectCompanyList
                    :selectCompanyData.sync="selectedList"
                    :selectCompanyListVisible.sync="selectCompanyListVisible"
                    @changeItemSelete="changeItemSelete"
                />
                <BatchOperateBar
                    v-if="isCheck"
                    :operateBarList="operateBarList"
                    @handleClickOperateType="handleClickOperateType"
                />
                <FooterTabbar :tabBarList="tabBarList" :tabBarActive="tabBarActive"></FooterTabbar>
                <ListAdvancedFiltering
                    v-if="searchPopupShow"
                    ref="listAdvancedFiltering"
                    :field_form="'customers'"
                    :system_fields="systemFilterFields"
                    @sendFilterData="getFilterData"
                />
                <CustomerDirectorChange
                    v-if="changeSalesPersonPopupShow"
                    :changeSalesPersonPopupShow.sync="changeSalesPersonPopupShow"
                    :companyList="selectedList"
                    @changeSuccess="onPullRefreshList"
                />
                <CustomerRecovery
                    v-if="customerRecoveryPopupShow"
                    :customerRecoveryPopupShow.sync="customerRecoveryPopupShow"
                    :companyList="selectedList"
                    @recoverySuccess="onPullRefreshList"
                />
            </div>
        </template>
    </PullContainer>
</template>

<script>
import { mapState } from "vuex";
import { pagination } from "@/mixins";
import { GetCustomerPrivateList, CustomerPrivateDel } from "@/api";
import { Dialog } from "vant";
import { EventBus } from '@/utils/eventBus';
import PullContainer from "@/components/mComponents/PullContainer.vue";
import ReturnNavBar from "@/components/mComponents/ReturnNavBar.vue";
import FooterTabbar from "@/components/mComponents/FooterTabbar.vue";
import BatchOperateBar from "./component/batch_operate_bar.vue";
import SelectCompanyList from "./component/select_company_list.vue";
import ListAdvancedFiltering from "@/components/mComponents/ListAdvancedFiltering";
import CustomerDirectorChange from "./customer_director_change.vue";
import CustomerRecovery from "./customer_recovery.vue";

export default {
    name: "CustomerPrivateSeas",
    components: {
        PullContainer,
        ReturnNavBar,
        FooterTabbar,
        BatchOperateBar,
        SelectCompanyList,
        ListAdvancedFiltering,
        CustomerDirectorChange,
        CustomerRecovery,
    },
    data() {
        return {
            loading: false,
            defaultImg: require("@/assets/images/default.jpg"),
            tabBarList: [
                {
                    icon: "icon-shouye",
                    activeIcon: "icon-shouyexuanzhong",
                    routerName: "MCustomerSeas",
                    title: "首页",
                },
                {
                    icon: "icon-a-fenzu450",
                    activeIcon: "icon-gonghai-xuanzhong",
                    routerName: "CustomerHighSeas",
                    title: "公海客户",
                },
                {
                    icon: "icon-sihai",
                    activeIcon: "icon-sihai-xuanzhong",
                    routerName: "CustomerPrivateSeas",
                    title: "私海客户",
                },
            ],
            tabBarActive: 2,
            searchForm: {
                keyword: "",
            },
            tableData: [],
            showOperatorPopover: false,
            operatorList: [
                { icon: "icon-a-shenling1", title: "新增客户", type: "add" },
                { icon: "icon-fenpei", title: "批量操作", type: "batch" },
            ],
            isCheck: false, // 是否批量选择
            selectedList: [], // 复选框选中数据
            selectCompanyListVisible: false, // 选择的公司列表
            operateBarList: [
                { icon: "icon-fenpei", title: "更换负责人", type: "changeDirector" },
                { icon: "icon-hebingkehu", title: "合并", type: "merge" },
                { icon: "icon-shouhui", title: "回收", type: "recovery" },
                { icon: "icon-shanchu1", title: "删除", type: "delete" },
            ],
            systemFilterFields: [], // 高级筛选字段
            custom_filter: {}, // 高级筛选确认条件
            // 更换负责人
            changeSalesPersonPopupShow: false,
            // 回收
            customerRecoveryPopupShow: false,
        };
    },
    mixins: [pagination],
    computed: {
        ...mapState(["searchPopupShow"]),
    },
    created() {
        EventBus.$on('customerAddUpdated', this.onPullRefreshList);
        EventBus.$on('customerEditUpdated', this.onPullRefreshList);
        this.showOperatorPopover = false;
        this.onPullRefreshList();
    },
    methods: {
        handleClickReturnRouter() {
            if(this.isCheck) {
                this.isCheck = false
            } else {
                if (this.$router.history.length <= 1) {
                    // 没有上一页，跳转到固定页面
                    this.$router.push({ name: 'mobileAllFunctions' });
                } else {
                    // 有上一页，后退
                    this.$router.go(-1);
                }
            }
        },
        pullDownLoadingSuccess(flag) {
            if (flag) {
                setTimeout(() => {
                    this.pullDownLoading = true;
                    this.onPullRefreshList();
                }, 3000);
            }
        },
        onSearch() {
            this.onPullRefreshList();
        },
        handleClickOperate(item) {
            this.showOperatorPopover = false;
            if (item.type === "batch") {
                // 批量操作
                this.isCheck = true;
            } else if (item.type === "add") {
                this.$router.push({
                    name: "MCustomerAdd",
                    query: {
                        addType: "private",
                    },
                });
            }
        },
        handleClickAdd() {
            this.$router.push({
                name: "MCustomerAdd",
                query: {
                    addType: "private",
                },
            });
        },
        handleClickChangeSelect(item) {
            if (item.checked) {
                this.selectedList.push(item);
            } else {
                const index = this.selectedList.findIndex((list) => list.id == item.id);
                this.selectedList.splice(index, 1);
            }
        },
        // 选中的公司列表弹框
        handleClickShowCompany() {
            this.selectCompanyListVisible = true;
        },
        // 复选框选中状态
        changeItemSelete(data) {
            if (data.type == "item") {
                // 取消单个选中
                const item = data.data;
                const list = this.tableData.find((list) => list.id === item.id);
                if (list) {
                    this.$set(list, "checked", false);
                }
            } else {
                // 取消全部的选择
                this.tableData.forEach((item) => {
                    this.$set(item, "checked", false);
                });
            }
        },
        // 批量操作确认类型
        handleClickOperateType(type) {
            if (!this.selectedList.length) return;
            switch (type) {
                case "changeDirector":
                    this.isCheck = false;
                    this.changeSalesPersonPopupShow = true;
                    break;
                case "recovery":
                    // 回收
                    this.isCheck = false;
                    this.customerRecoveryPopupShow = true;
                    break;
                case "delete":
                    Dialog.confirm({
                        title: "提示",
                        message: `确定<span class="text_red">删除</span>选中的客户吗？`,
                        className: "my_dialog",
                        confirmButtonColor: "rgba(41, 144, 255, 1)",
                        confirmButtonText: "确定",
                    })
                        .then(() => {
                            const ids = this.selectedList.map((item) => item.id);
                            CustomerPrivateDel({ customer_ids: ids }).then((res) => {
                                if (res.code === 200) {
                                    this.isCheck = false;
                                    this.$toast({
                                        message: res.message,
                                        type: "success",
                                        duration: 1000,
                                        onClose: () => {
                                            this.onPullRefreshList();
                                        },
                                    });
                                } else {
                                    this.$toast({
                                        message: res.message,
                                        type: "fail",
                                    });
                                }
                            });
                        })
                        .catch(() => {
                            // on cancel
                        });
                    break;
                case "merge":
                    if (this.selectedList.length < 2) return this.$toast("请至少选择两个及以上的客户");
                    const ids = this.selectedList.map((item) => item.id);
                    localStorage.setItem("customerMergeIds", JSON.stringify(ids));
                    // 合并
                    this.$router.push({
                        name: "MCustomerMerge",
                    });
                    break;
            }
        },
        // 跳转详情页面
        handleClickToDetail({ id, name }) {
            this.$router.push({
                name: "CustomerPrivateSeasDetail",
                params: {
                    isPush: true,
                },
                query: {
                    customer_id: id,
                    name: name.value,
                },
            });
        },
        // 点击高级筛选
        handleClickAdvancedFilter() {
            this.$store.dispatch("searchPopupShow", true);
        },
        // 获取高级筛选数据
        getFilterData(data) {
            this.custom_filter = data;
            this.onPullRefreshList();
        },
        onPullRefreshList() {
            this.loading = true;
            this.pagination.pageNum = 1;
            this.tableData = [];
            this.getTableData();
        },
        onLoadList() {
            if (this.pagination.total == this.tableData.length) {
                return false;
            }
            if (this.loading == false) {
                this.getTableData();
            }
        },
        getTableData() {
            this.loading = true;
            const params = {
                keyword: this.searchForm.keyword,
                page: this.pagination.pageNum,
                pageSize: this.pagination.pageSize,
            };
            GetCustomerPrivateList(params).then((res) => {
                if (res.code === 200) {
                    const { data, total } = res.data;
                    this.tableData = this.tableData.concat(data);
                    this.pagination.total = total;
                    this.pagination.pageNum++;
                    this.loading = false;
                    if (this.pullDownLoading) {
                        this.pullDownLoading = false;
                        this.$refs.pullContainerRef.pullDownLoadingEnd("刷新成功");
                    }
                } else {
                    // 取消全部的选择
                    this.tableData.forEach((item) => {
                        this.$set(item, "checked", false);
                    });
                }
            });
        },
    },
    beforeDestroy() {
        EventBus.$off('customerAddUpdated', this.initData);
        EventBus.$off('customerEditUpdated', this.initData);
    },
};
</script>

<style lang="scss" scoped>
@import "@/styles/m_style/customers.scss";

.customer_private_seas_wrap {
    .mobile_container {
        overflow-y: auto;
        overflow-x: hidden;
        padding: 10px 16px;
    }
}
</style>
<style lang="scss">
.van-popover {
    .van-popover__arrow {
        display: none;
    }
}

.top_operator_list {
    width: 104px;
    padding: 4px 0;

    li {
        list-style: none;
        width: 100%;
        height: 38px;
        line-height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 8px;

        span {
            font-size: 14px;
            font-weight: 400;
            letter-spacing: 0px;
            color: rgba(51, 51, 51, 1);
        }

        &:active {
            background-color: rgba(153, 153, 153, 0.04);
        }
    }
}
</style>
